module.exports = __webpack_public_path__ + "img/university.d7666053.svg";